import { AstraChip, AstraParagraph } from '~/astra'
import { Practitioner, usePractitioner } from '~/storm'
import { getPractitionerFullname } from '~/utils/dips'

import { useOpenDialog } from '../DialogRouter/useDialogRouter'
import { PractitionerChipWithTooltip } from '../PractitionerChip'

export const PractitionerPreviewHeader = ({ practitioner }: { practitioner: Practitioner }) => {
    const openPractitionerPopover = useOpenDialog('practitioner')

    const practitionerPopulated = usePractitioner({
        where: {
            id: practitioner.id,
        },
        include: {
            departments: true,
            dipsResource: true,
        },
    })

    const practitionerName = getPractitionerFullname(practitionerPopulated)

    return (
        <div className="flex flex-col gap-x-2 divide-x border-b border-subtle pb-3">
            <div className="flex flex-col gap-y-1.5 px-4">
                <AstraParagraph
                    variant="body-large"
                    weight="strong"
                    className="cursor-pointer text-default hover:underline"
                    onClick={() => openPractitionerPopover({ practitioner })}
                >
                    {practitionerName}
                </AstraParagraph>
                <div className="flex items-center gap-1.5">
                    <PractitionerChipWithTooltip shortName={practitioner.short_name} fullName={practitionerName} />
                    {practitionerPopulated?.departments.map(department => <AstraChip key={department.uuid} label={department.name} />)}
                </div>
            </div>
        </div>
    )
}
